<template>
    <div v-if="campagne" class="columns is-multiline">
      <div class="column is-10">
        <div class="mgt-20px">
          <div class="card">
            <header class="header-card">
              <p>{{ $t('detailCampagne.informationsHeader')}}</p>
            </header>
            <div class="card-content">
              <div class="columns is-multiline">
                <div class="column is-12 columns is-multiline">
                  <b-field :label="$t('detailCampagne.informations.libelle')"
                    custom-class="has-text-weight-normal is-italic is-marginless"
                    class="column is-6 mgb-0">
                    <span class="has-text-weight-bold">
                      {{ campagne.libelle }}
                    </span>
                  </b-field>
                  <b-field :label="$t('detailCampagne.informations.libelleInterne')"
                    custom-class="has-text-weight-normal is-italic is-marginless"
                    class="column is-6 mgb-0">
                    <span class="has-text-weight-bold">
                      {{ campagne.libelleInterne }}
                    </span>
                  </b-field>
                  <b-field :label="$t('detailCampagne.informations.marque')"
                    custom-class="has-text-weight-normal is-italic is-marginless"
                    class="column is-6 mgb-0">
                    <span class="has-text-weight-bold">
                      {{ campagne.marque.libelle }}
                    </span>
                  </b-field>
                  <b-field :label="$t('detailCampagne.informations.tags')"
                    custom-class="has-text-weight-normal is-italic is-marginless"
                    class="column is-6 mgb-0">
                    <query-tags-tag-input class="mgt-2px"
                      v-model="campagne.tags"
                      field="tag"
                      is-detail>
                    </query-tags-tag-input>
                  </b-field>
                  <b-field :label="$t('detailCampagne.informations.dateDebut')"
                    custom-class="has-text-weight-normal is-italic is-marginless"
                    class="column is-6 mgb-0">
                    <span class="has-text-weight-bold">
                      {{ formatDate(campagne.dateDebut) }}
                    </span>
                  </b-field>
                  <b-field :label="$t('detailCampagne.informations.dateFin')"
                    custom-class="has-text-weight-normal is-italic is-marginless"
                    class="column is-6 mgb-0">
                    <span class="has-text-weight-bold">
                      {{ formatDate(campagne.dateFin) }}
                    </span>
                  </b-field>
                  <b-field :label="$t('detailCampagne.informations.newsLetter')"
                    custom-class="has-text-weight-normal is-italic is-marginless"
                    class="column is-6 mgb-0">
                    <span class="has-text-weight-bold">
                      {{ campagne.newsLetter ?
                          $t('general.oui')
                          : $t('general.non')
                      }}
                    </span>
                  </b-field>
                  <b-field :label="$t('detailCampagne.informations.visibleParLaMarque')"
                    custom-class="has-text-weight-normal is-italic is-marginless"
                    class="column is-6 mgb-0">
                    <span class="has-text-weight-bold">
                      {{ campagne.visibleParLaMarque ?
                          $t('general.oui')
                          : $t('general.non')
                      }}
                    </span>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <figure class="mgt-20px is-justify-content-center">
          <app-logo readOnly class="max-height-700"
            :elementId="campagne.id"
            :imageFillHeightKeepAspectInView="true"
            :libelleElement="$t('detailCampagne.libelleForLogo',
            { libelle: campagne.libelle })">
          </app-logo>
        </figure>
        <div class="card mgt-20px">
          <header class="header-card">
            <p>
              {{ $t('piecesJointes.attachments')}}
            </p>
          </header>
          <div class="card-content">
            <app-pieces-jointes readOnly
              deletable
              autoSave
              :checkPermissions="checkPermissions(permCampagne.maj)"/>
          </div>
        </div>
      </div>
      <div class="column is-2 pdt-0 pdb-10px">
        <div class="is-fixed">
          <information-create-update-user :data="campagne" class="mgr-20px">
          </information-create-update-user>
        </div>
      </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import { CAMPAGNE } from '@/configuration/permissionsBodacConf';
import Logo from '@/components/general/Logo';
import PiecesJointes from '@/components/general/piecesJointes';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import formatDate from '@/services/general/formatDate';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'detailCampagne',
  props: {
    campagne: {
      type: Object,
      required: true,
    },
  },
  components: {
    queryTagsTagInput,
    appLogo: Logo,
    appPiecesJointes: PiecesJointes,
    InformationCreateUpdateUser,
  },
  data() {
    return {
      permCampagne: CAMPAGNE,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    formatDate(date) {
      return formatDate(date);
    },
  },
};
</script>

<style>

</style>
